import { render, staticRenderFns } from "./CanalMessenger.vue?vue&type=template&id=0d1484d4&lang=pug"
import script from "./CanalMessenger.vue?vue&type=script&lang=js"
export * from "./CanalMessenger.vue?vue&type=script&lang=js"
import style0 from "./CanalMessenger.vue?vue&type=style&index=0&id=0d1484d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports